<template>
    <div v-if="!isMobile">
        <ul class="tags" v-if="!+album.hide_tags && staticTags && staticTags.length > 0" :style="staticTags ? 'margin-top: 30px' : ''">
            <li class="tags__item">
                <a href="#" @click.prevent="setActiveTag(null)" :class="['tag', {'tag--active': !activeTag}]">{{ $t('show_all') }}</a>
            </li>
            <template v-for="(tag, i) in staticTags">
                <li v-if="!+tag.hide_tag_in_frontend" class="tags__item" :key="i">
                    <a href="#" :id="`tag-${!!tag.password_hash ? `${tag.hash}-${tag.password_hash}`: tag.hash}${isMorePhotosSection ? '-more-photos': ''}`" @click.prevent="setActiveTag(tag)" :class="['tag', {'tag--active': activeTag && activeTag.id === tag.id}]">
                        <template v-if="!!tag.password_hash">
                            <span v-if="!isOpenTag(tag)" class="material-icon icon-lock_outline"></span>
                            <span v-else class="material-icon icon-lock_open"></span>
                        </template>
                        {{ tag.name }}
                    </a>
                    <b-tooltip placement="top" v-if="!!tag.password_hash" :target="`tag-${!!tag.password_hash ? `${tag.hash}-${tag.password_hash}`: tag.hash}${isMorePhotosSection ? '-more-photos': ''}`">
                        {{ $t('helpers.protected_photos') }}
                    </b-tooltip>
                </li>
            </template>
            <li v-if="hasPrivateTags" class="tags__item">
                <a href="#" @click.prevent="showSecuredTagModal()" class="tag"><!--:class="{'tag--active': isPrivateTag}"-->
                    <!--<span v-if="isPrivateTag" class="material-icon icon-lock_open"></span>-->
                    <span class="material-icon icon-lock_outline"></span>
                    {{ $t('open_password_protected_images') }}
                </a>
            </li>
        </ul>
    </div>
    <div v-else>
        <div v-if="!+album.hide_tags && staticTags && staticTags.length > 0" class="mobile-common-menu" :class="{'mobile-common-menu--open': mobileTagMenu}">
            <template v-if="mobileTagMenu">
                <div class="mobile-common-menu__container js-mobile-menu-container">
                    <div class="mobile-common-menu__container-inner">
                        <div class="mobile-common-menu__content">
                            <ul class="mobile-common-menu__links">
                                <li class="mobile-common-menu__link">
                                    <a href="#" @click.prevent="setActiveTag(null)" :class="{'active': !activeTag}">{{ $t('show_all') }}</a>
                                </li>
                                <template v-for="(tag, i) in staticTags">
                                    <li v-if="!+tag.hide_tag_in_frontend" class="mobile-common-menu__link" :key="i">
                                        <a href="#" :id="`tag-${!!tag.password_hash ? `${tag.hash}-${tag.password_hash}`: tag.hash}${isMorePhotosSection ? '-more-photos': ''}`" @click.prevent="setActiveTag(tag)" :class="{'active': activeTag && activeTag.id === tag.id}">
                                            <template v-if="!!tag.password_hash">
                                                <span v-if="!isOpenTag(tag)" class="material-icon icon-lock_outline"></span>
                                                <span v-else class="material-icon icon-lock_open"></span>
                                            </template>
                                            {{ tag.name }}
                                        </a>
                                    </li>
                                </template>
                                <li v-if="hasPrivateTags" class="mobile-common-menu__link">
                                    <a href="#" @click.prevent="showSecuredTagModal()"> <!--:class="{'active': isPrivateTag}"-->
                                        <!--<span v-if="isPrivateTag" class="material-icon icon-lock_open"></span>-->
                                        <span class="material-icon icon-lock_outline"></span>
                                        {{ $t('open_password_protected_images') }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <ul class="mobile-common-menu__actions">
                    <li class="mobile-common-menu__action">
                        <a href="#" class="action-link" @click.prevent="setActiveTag(null)">
                            <span class="material-icon icon-rotate_left"/>
                            {{ $t('reset') }}
                        </a>
                    </li>
                </ul>
                <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_TAG_MENU', false)"
                   class="mobile-common-menu__btn -red">
                    <span class="material-icon icon-clear"/>
                </a>
            </template>
            <div v-else id="tags" class="tags" :style="tags ? 'margin-top: 20px' : ''">
                <div class="tags__item">
                    <a href="#" @click.prevent="$store.dispatch('SET_MOBILE_TAG_MENU', true)" class="tag">
                        <span class="material-icon icon-keyboard_arrow_down"/>
                        <template v-if="activeTag">{{ activeTag.name }}</template>
                        <template v-else>{{ $t('show_all') }}</template>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .tags {
        display: flex;
        flex-wrap: wrap;
        margin: 0 0 -7px;
        padding: 0;
        list-style: none;

        &.-hide {
            display: none;
        }

        &__item {
            display: inline-flex;
            margin-right: 7px;
            margin-bottom: 7px;

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .tag {
        display: flex;
        align-items: center;
        height: 36px;
        line-height: 36px;
        padding: 0 14px;
        border-radius: 18px;
        color: var(--text-color);
        font-size: .87rem;
        background-color: var(--bg-secondary-color);
        white-space: nowrap;
        transition: background-color .3s ease;

        &,
        &:hover,
        &:focus {
            text-decoration: none;
        }

        &:hover {
            color: var(--text-color);
            background-color: var(--bg-color);
        }

        &--active {

            &,
            &:hover {
                color: var(--bg-color);
                background-color: var(--text-color);
            }
        }

        .material-icon {
            position: relative;
            margin: 1px 5px 0 0;
            font-size: 1rem !important;
        }
    }
</style>

<script>
  import tags from 'src/mixins/tagsComponent';

  export default {
    mixins: [tags],
  };
</script>
